export const authRoles = {
  sa: ['SA'], // Only Super Admin has access
  admin: ['SA', 'ADMIN'], // Only SA & Admin has access
  employee: ['SA', 'ADMIN', 'EDITOR'], // Only SA & Admin & Editor has access
  hr: ['SA', 'ADMIN', 'EDITOR', 'GUEST'] // Everyone has access
};
